<template>
  <table class="table table-sm mb-0 sale-info-table">
    <tr>
      <td class="font-weight-bold border-top-0">{{ $t('Sale') }}</td>
      <td class="border-top-0">{{ sale.sale_no }}
        <live-sale-ref v-if="sale.live_reference" :href="sale.live_url" :label="sale.live_reference"/>
      </td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Dates') }}</td>
      <td>
        <div v-if="sale.type === 'live'">
          <div v-for="date in sale.dates" :key="date.uuid">
            {{ date.start_date | toDateTime }}
          </div>
        </div>
        <div v-else-if="enableTimedSessions && sale.type === 'timed'">
          <div v-for="date in sale.dates" :key="date.uuid">
            {{ date.start_date | toDateTime }} - {{ date.end_date | toDateTime }}
          </div>
        </div>
        <div v-else>
          {{ sale.start_date | toDateTime }} - {{ sale.end_date | toDateTime }}
        </div>
      </td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Title') }}</td>
      <td>{{ sale.title | masterLanguage }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Type') }}</td>
      <td>{{ sale.type | toUpperCaseFirst | translate }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Branch') }}</td>
      <td>
        <router-link v-if="sale.branch"
                     :to="{name: 'branches', params: {branch_uuid: sale.branch_uuid}}">
          {{ sale.branch.name }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Department') }}</td>
      <td>
        <router-link v-if="sale.department"
                     :to="{name: 'departments', params: {department_uuid: sale.department_uuid}}">
          {{ sale.department.name | masterLanguage }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Bid Cut Off Minutes') }}</td>
      <td>{{ sale.bid_cut_off_minutes }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold border-top-0">{{ $t('Currency') }}</td>
      <td class="border-top-0">{{ sale.currency.code }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Payment Terms') }}</td>
      <td>{{ sale.payment_terms }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Settlement Days') }}</td>
      <td>{{ sale.settlement_days }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Live Auctions ref.') }}</td>
      <td>
        <a :href="sale.live_url" target="_blank">{{ sale.live_reference }}</a>
      </td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t('Hammer Target') }}</td>
      <td>{{ sale.hammer_target }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t("Auctioneer's Sheet Status") }}</td>
      <td>{{ sale.auctioneers_sheet_status | translate }}</td>
    </tr>
    <tr>
      <td class="font-weight-bold">{{ $t("After Sale Auctioneer's Sheet Status") }}</td>
      <td>{{ sale.after_sale_auctioneers_sheet_status | translate }}</td>
    </tr>
    <tr v-if="vendorBuyerGroupAccountsEnabled">
      <td class="font-weight-bold">{{ $t('Buyer Group Account') }}</td>
      <td>{{ sale.buyer_group_account }}</td>
    </tr>
    <tr v-if="vendorBuyerGroupAccountsEnabled">
      <td class="font-weight-bold">{{ $t('Vendor Group Account') }}</td>
      <td>{{ sale.vendor_group_account }}</td>
    </tr>
    <template v-if="sale.dynamic_fields">
      <dynamic-fields-info-table :dynamic-fields="sale.dynamic_fields" only-rows
                                 :dynamic-fields-template="sortedAuctionDynamicFieldsTemplate"/>
    </template>
  </table>
</template>

<script>
  import LiveSaleRef from "@/core/components/common/LiveSaleRef";
  import _ from "lodash";
  import DynamicFieldsInfoTable from "@/modules/inventory/view/dashboard/DynamicFieldsInfoTable";
  import {createNamespacedHelpers} from "vuex";

  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "SaleInfoTable",
    components: {DynamicFieldsInfoTable, LiveSaleRef},
    props: ['sale'],
    computed: {
      ...globalMapState(['enableTimedSessions', 'vendorBuyerGroupAccountsEnabled']),
      sortedAuctionDynamicFieldsTemplate() {
        if (!this.sale.branch ||
          !this.sale.branch.auction_dynamic_fields_template ||
          !this.sale.branch.auction_dynamic_fields_template[this.sale.type]) {
          return []
        }
        return _.orderBy(Object.keys(this.sale.branch.auction_dynamic_fields_template[this.sale.type]).map(key => {
          return {key, ...this.sale.branch.auction_dynamic_fields_template[this.sale.type][key]}
        }), ['position'], ['asc'])
      }
    }
  }
</script>

<style scoped>

</style>
